import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AxiosInstance from '../../../../../Config/AxiosInstance';
import APILIST from '../../../../../Config/ApiList';
import {
    Box,
    Typography,
    Grid,
    Avatar,
    Paper,
    Divider,
    Card,
    CardContent,
    Chip,
    Grid2,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventIcon from '@mui/icons-material/Event';
import CancelIcon from '@mui/icons-material/Cancel';
import TopHeader from '../../../../../Components/TopHeader/TopHeader'
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent } from '@mui/lab';
import Constant from '../../../../../Utils/Constant';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment';

const UserSessionFullDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [session, setSession] = useState(null);

    useEffect(() => {
        if (location?.state?.userSessionID) {
            getSessionDetails(location.state.userSessionID);
        }
    }, [location?.state?.userSessionID]);

    const getSessionDetails = async (sessionID) => {
        try {
            const response = await AxiosInstance.get(APILIST.GET_SESSION_DETAILS, {
                params: { job_id: sessionID },
            });
            if (response?.data?.s) {
                setSession(response.data.r);
            } else {
                setSession(null);
            }
        } catch (error) {
            console.error('Error fetching session details:', error);
            setSession(null);
        }
    };

    const user = session?.user_details;
    const interpreter = session?.interpreter_details;
    const extraHoursRequest = session?.extra_hours_request;
    const extraHoursDetails = session?.extra_hours_details;
    const totalExtra = session?.total_extra_jobs_and_hours;

    const getTimelineContent = (status) => {
        switch (status) {
            case 1: return 'In Route';
            case 2: return 'Arrived';
            case 3: return 'Start';
            case 4: return 'Pause';
            case 5: return 'Resume ';
            case 6: return 'Completed';
            case 7: return 'Incomplete';
            default: return 'Checkout';
        }
    };

    const getRequestStatus = (status) => {
        switch (status) {
            case 1: return 'Accepted';
            case 2: return 'Rejected';
            default: return 'Pending';
        }
    };

    return (
        <Fragment>
            <TopHeader
                title={"Session Details"}
                onClick={() => navigate(-1)}
                type="button"
                showButton={false}
            />
            <Box
                sx={{
                    padding: "60px 15px 0px 15px",
                    maxWidth: { xs: "100%" },
                    margin: "0 auto",
                    width: "100%",
                }}
            >
                <Card
                    sx={{
                        background: "rgba(230, 245, 247, 1)",
                        position: "relative",
                        width: '100%'
                    }}
                >
                    <CardContent>
                        {session ? (
                            <Grid container spacing={3}>
                                {/* User Info */}
                                <Grid item xs={12} md={6}>
                                    <Typography sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left',
                                        marginBottom: '10px'
                                    }}>Client</Typography>
                                    <Box display="flex" alignItems="center" gap={2} mt={1}>
                                        <Avatar src={`${Constant.BASE_URL}${user?.profile_img}` || ''} alt={user?.full_name} />
                                        <Box onClick={() => {
                                            navigate(`/admin/user-details`, {
                                                state: { id: user?.id },
                                            });
                                        }} sx={{
                                            cursor: 'pointer'
                                        }}>
                                            <Typography
                                                sx={{
                                                    fontSize: "16px",
                                                    fontWeight: "300",
                                                    color: "rgba(0, 0, 0, 0.7)",
                                                    textAlign: "left",
                                                    width: "100%",
                                                    fontFamily: "Outfit"
                                                }}
                                            >
                                                Full Name
                                            </Typography>
                                            <Typography sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}>{user?.full_name}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>

                                {/* Interpreter Info */}
                                <Grid item xs={12} md={6}>
                                    <Typography sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left',
                                        marginBottom: '10px'
                                    }}>Interpreter</Typography>
                                    <Box display="flex" alignItems="center" gap={2} mt={1}>
                                        <Avatar src={`${Constant.BASE_URL}${interpreter?.profile_img}` || ''} alt={interpreter?.full_name} />
                                        <Box onClick={() => {
                                            navigate(`/admin/interpreter-details`, {
                                                state: { id: interpreter?.id },
                                            });
                                        }} sx={{
                                            cursor: 'pointer'
                                        }}>
                                            <Typography
                                                sx={{
                                                    fontSize: "16px",
                                                    fontWeight: "300",
                                                    color: "rgba(0, 0, 0, 0.7)",
                                                    textAlign: "left",
                                                    width: "100%",
                                                    fontFamily: "Outfit"
                                                }}
                                            >
                                                Full Name
                                            </Typography>
                                            <Typography sx={{
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                color: "rgba(8, 85, 127, 1)",
                                                textAlign: "left",
                                                width: "100%",
                                                paddingTop: "4px",
                                                textTransform: "capitalize",
                                                fontFamily: "Outfit"
                                            }}>{interpreter?.full_name}</Typography>
                                            {interpreter?.is_premium === 1 && <Typography
                                                sx={{
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    color: "rgba(0, 0, 0, 0.7)",
                                                    textAlign: "center",
                                                    width: "100%",
                                                    fontFamily: "Outfit",
                                                    background: '#F9B600',
                                                    borderRadius: '10px',
                                                    padding: '5px 5px',
                                                    position: 'absolute',
                                                    bottom: '-32px',
                                                }}
                                            >
                                                Premium
                                            </Typography>}
                                        </Box>
                                    </Box>
                                </Grid>

                                {/* Location and Date */}
                                <Grid item xs={12}>
                                    <Divider sx={{ my: 2 }} />
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <LocationOnIcon color="primary" />
                                        <Typography sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}>{session?.location}</Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={2} mt={1}>
                                        <EventIcon color="action" />
                                        <Typography sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}>
                                            {new Date(session.date_time).toLocaleDateString()} - {new Date(session.date_time).toLocaleTimeString()} to {new Date(session.end_time).toLocaleTimeString()}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={2} mt={1}>
                                        <AccessTimeIcon color="action" />
                                        <Typography sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}>{session.estimated_hours} hour(s)</Typography>
                                    </Box>
                                </Grid>

                                {/* Extra Hours Request Section */}
                                {extraHoursRequest && (
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 2 }} />
                                        <Typography sx={{
                                            color: "rgba(0, 151, 178, 1)",
                                            fontSize: { xs: '18px', md: "22px" },
                                            fontWeight: "500",
                                            fontFamily: 'Outfit',
                                            textAlign: 'left',
                                            marginBottom: '10px'
                                        }}>Extra Hours Request</Typography>

                                        <Box sx={{
                                            background: '#f5f5f5',
                                            p: 2,
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 2
                                        }}>
                                            {extraHoursRequest.is_accepted === 1 ? (
                                                <CheckCircleIcon color="success" />
                                            ) : (
                                                <HourglassEmptyIcon color="warning" />
                                            )}
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    fontFamily: 'Outfit',
                                                    color: '#08557F'
                                                }}>
                                                    Requested Hours: {extraHoursRequest.hours} hour(s)
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '14px',
                                                    fontFamily: 'Outfit',
                                                    color: '#555'
                                                }}>
                                                    Status: {getRequestStatus(extraHoursRequest.request_status)}
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '12px',
                                                    fontFamily: 'Outfit',
                                                    color: '#777',
                                                    mt: 1
                                                }}>
                                                    Requested on: {new Date(extraHoursRequest.created_at).toLocaleString()}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )}

                                {/* Extra Hours Details Section */}
                                {extraHoursDetails && (
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 2 }} />
                                        <Typography sx={{
                                            color: "rgba(0, 151, 178, 1)",
                                            fontSize: { xs: '18px', md: "22px" },
                                            fontWeight: "500",
                                            fontFamily: 'Outfit',
                                            textAlign: 'left',
                                            marginBottom: '10px'
                                        }}>Extra Hours Session Details</Typography>

                                        <Card sx={{ background: '#f9f9f9', mb: 2 }}>
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            color: "rgba(0, 0, 0, 0.7)",
                                                            fontFamily: "Outfit"
                                                        }}>
                                                            Session ID: <span style={{ fontWeight: "500", color: "#08557F" }}>{extraHoursDetails.id}</span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            color: "rgba(0, 0, 0, 0.7)",
                                                            fontFamily: "Outfit"
                                                        }}>
                                                            Hours: <span style={{ fontWeight: "500", color: "#08557F" }}>{extraHoursDetails.estimated_hours}</span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            color: "rgba(0, 0, 0, 0.7)",
                                                            fontFamily: "Outfit"
                                                        }}>
                                                            Date: <span style={{ fontWeight: "500", color: "#08557F" }}>
                                                                {new Date(extraHoursDetails.date_time).toLocaleDateString()}
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            color: "rgba(0, 0, 0, 0.7)",
                                                            fontFamily: "Outfit"
                                                        }}>
                                                            Time: <span style={{ fontWeight: "500", color: "#08557F" }}>
                                                                {new Date(extraHoursDetails.date_time).toLocaleTimeString()} - {new Date(extraHoursDetails.end_time).toLocaleTimeString()}
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            color: "rgba(0, 0, 0, 0.7)",
                                                            fontFamily: "Outfit"
                                                        }}>
                                                            Amount: <span style={{ fontWeight: "500", color: "#08557F" }}>${extraHoursDetails.amount}</span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            color: "rgba(0, 0, 0, 0.7)",
                                                            fontFamily: "Outfit"
                                                        }}>
                                                            Payment Status: <span style={{ fontWeight: "500", color: "#08557F" }}>
                                                                {extraHoursDetails.payment_status || 'N/A'}
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography sx={{
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            color: "rgba(0, 0, 0, 0.7)",
                                                            fontFamily: "Outfit"
                                                        }}>
                                                            Status: <Chip
                                                                label={extraHoursDetails.job_status === 3 ? 'Completed' : 'Pending'}
                                                                color={extraHoursDetails.job_status === 3 ? 'success' : 'warning'}
                                                                size="small"
                                                            />
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )}

                                {/* Total Extra Jobs and Hours */}
                                {totalExtra && totalExtra.flag === 1 && (
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 2 }} />
                                        <Typography sx={{
                                            color: "rgba(0, 151, 178, 1)",
                                            fontSize: { xs: '18px', md: "22px" },
                                            fontWeight: "500",
                                            fontFamily: 'Outfit',
                                            textAlign: 'left',
                                            marginBottom: '10px'
                                        }}>Extra Sessions Summary</Typography>

                                        <Box sx={{
                                            background: '#e8f4f8',
                                            p: 2,
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 2
                                        }}>
                                            <InfoIcon color="info" />
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    fontFamily: 'Outfit',
                                                    color: '#08557F'
                                                }}>
                                                    Total Extra Sessions: {totalExtra.total_extra_jobs}
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    fontFamily: 'Outfit',
                                                    color: '#08557F'
                                                }}>
                                                    Total Hours: {totalExtra.total_extra_hours} hour(s)
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )}
                                
                                {/* Session Status */}
                                <Grid item xs={12}>
                                    <Divider sx={{ my: 2 }} />
                                    <Typography sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left',
                                        marginBottom: '10px'
                                    }}>Session Status</Typography>
                                    <Box sx={{
                                        padding: '15px',
                                        borderRadius: '15px',
                                        width: '100%',
                                        cursor: 'pointer',
                                        border:'1px solid #ddd',
                                        marginBottom:'10px'
                                    }}>
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}>
                                            <Typography variant="h6"
                                                sx={{
                                                    color: "#000",
                                                    fontSize: { xs: '16px', md: "18px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Outfit",
                                                    paddingLeft: '10px',
                                                    color: "rgba(8, 85, 127, 1)"
                                                }}>
                                                {session?.title}
                                            </Typography>
                                            <Typography sx={{
                                                background: "rgba(0, 151, 178, 0.2)",
                                                padding: '4px 10px',
                                                borderRadius: '22px',
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                fontFamily: "Outfit",
                                                width: 'fit-content',
                                                color: 'rgba(2, 56, 85, 1)'
                                            }}>
                                                {session?.service_type ? session?.service_type === 1
                                                    ? "Onsite"
                                                    : session?.service_type === 2
                                                        ? "Virtual"
                                                        : "Both" : "N/A"}
                                            </Typography>
                                        </Box>

                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            padding: '10px 0px 0px 0px'
                                        }}>
                                            <Typography variant="h6"
                                                sx={{
                                                    color: "rgba(0, 0, 0, 1)",
                                                    fontSize: { xs: '14px', md: "14px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Outfit",
                                                    paddingLeft: '10px'
                                                }}>Location:</Typography>
                                            <Typography sx={{
                                                padding: '4px 10px',
                                                borderRadius: '22px',
                                                fontSize: '12px',
                                                fontFamily: "Outfit",
                                            }}>
                                                {session?.location}
                                            </Typography>
                                        </Box>

                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                        }}>
                                            <Typography variant="h6"
                                                sx={{
                                                    color: "rgba(0, 0, 0, 1)",
                                                    fontSize: { xs: '14px', md: "14px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Outfit",
                                                    paddingLeft: '10px'
                                                }}>Date:</Typography>
                                            <Typography sx={{
                                                padding: '4px 10px',
                                                borderRadius: '22px',
                                                fontSize: '12px',
                                                fontFamily: "Outfit",
                                            }}>
                                                {moment(session?.date_time).format('DD/MM/YYYY')}
                                            </Typography>
                                        </Box>

                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                        }}>
                                            <Typography variant="h6"
                                                sx={{
                                                    color: "rgba(0, 0, 0, 1)",
                                                    fontSize: { xs: '14px', md: "14px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Outfit",
                                                    paddingLeft: '10px'
                                                }}>Language :</Typography>
                                            <Typography sx={{
                                                padding: '4px 10px',
                                                borderRadius: '22px',
                                                fontSize: '12px',
                                                fontFamily: "Outfit",
                                            }}>
                                                {session?.from_language || "N/A"} → {session?.to_language || "N/A"}
                                            </Typography>
                                        </Box>

                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                        }}>
                                            <Typography variant="h6"
                                                sx={{
                                                    color: "rgba(0, 0, 0, 1)",
                                                    fontSize: { xs: '14px', md: "14px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Outfit",
                                                    paddingLeft: '10px'
                                                }}>Time:</Typography>
                                            <Typography sx={{
                                                padding: '4px 10px',
                                                borderRadius: '22px',
                                                fontSize: '12px',
                                                fontFamily: "Outfit",
                                            }}>
                                                {moment(session?.date_time).local().format('hh:mm A')}
                                            </Typography>
                                        </Box>

                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                        }}>
                                            <Typography variant="h6"
                                                sx={{
                                                    color: "rgba(0, 0, 0, 1)",
                                                    fontSize: { xs: '14px', md: "14px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Outfit",
                                                    paddingLeft: '10px'
                                                }}>Total Hours:</Typography>
                                            <Typography sx={{
                                                padding: '4px 10px',
                                                borderRadius: '22px',
                                                fontSize: '12px',
                                                fontFamily: "Outfit",
                                            }}>
                                                {session?.estimated_hours}
                                            </Typography>
                                        </Box>

                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                        }}>
                                            <Typography variant="h6"
                                                sx={{
                                                    color: "rgba(0, 0, 0, 1)",
                                                    fontSize: { xs: '14px', md: "14px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Outfit",
                                                    paddingLeft: '10px'
                                                }}>Payment:</Typography>
                                            <Typography sx={{
                                                padding: '4px 10px',
                                                borderRadius: '22px',
                                                fontSize: '12px',
                                                fontFamily: "Outfit",
                                            }}>
                                                {session?.payment_status || "N/A"}
                                            </Typography>
                                        </Box>

                                        {/* <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            paddingTop: "10px"
                                        }}>
                                            {elem?.user_details && <>
                                                <img
                                                    src={elem?.user_details?.profile_img ? `${Constant.BASE_URL}${elem?.user_details?.profile_img}` : 'https://res.cloudinary.com/do0g7smfg/image/upload/v1711695886/cld-sample-3.jpg'}
                                                    alt='user' style={{
                                                        width: '40px',
                                                        height: '40px',
                                                        borderRadius: '50%'
                                                    }}
                                                />
                                                <Typography sx={{
                                                    padding: '4px 10px',
                                                    borderRadius: '22px',
                                                    fontSize: { xs: '14px', md: "14px" },
                                                    fontWeight: '500',
                                                    fontFamily: "Outfit",
                                                }}>
                                                    {elem?.user_details?.full_name}
                                                </Typography>
                                            </>}
                                        </Box> */}
                                    </Box>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Job Status: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session.job_status > 3 ? 'Completed' : 'Pending'}</span></Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Cancelled: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session.is_cancelled ? 'Yes' : 'No'}</span></Typography>
                                    {session?.is_cancelled === 1 && (
                                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                                            <CancelIcon color="error" />
                                            <Typography color="error">Reason: {session.cancel_reason}</Typography>
                                        </Box>
                                    )}
                                </Grid>

                                {/* Languages & Assignment */}
                                <Grid item xs={12} md={6}>
                                    <Typography sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left',
                                        marginBottom: '10px'
                                    }}>Languages</Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>From: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session.from_language}</span></Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>To:  <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session.to_language}</span></Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left',
                                        marginBottom: '10px'
                                    }}>Assignment</Typography>
                                    <Typography sx={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session.assignment}</Typography>
                                </Grid>

                                {/* Payment Info */}
                                <Grid item xs={12}>
                                    <Divider sx={{ my: 2 }} />
                                    <Typography sx={{
                                        color: "rgba(0, 151, 178, 1)",
                                        fontSize: { xs: '18px', md: "22px" },
                                        fontWeight: "500",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left',
                                        marginBottom: '10px'
                                    }}>Payment Info</Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Payment ID: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session?.payment_intent}</span></Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Transaction ID: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session?.transaction_id}</span></Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Amount: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>${session.amount}</span></Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Commission: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>${session.commission}</span></Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Payment Status: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session.payment_status}</span></Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "Outfit"
                                    }}>Refund Status: <span style={{
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        color: "rgba(8, 85, 127, 1)",
                                        textAlign: "left",
                                        width: "100%",
                                        paddingTop: "4px",
                                        fontFamily: "Outfit"
                                    }}>{session.refund_status || 'N/A'}</span></Typography>
                                </Grid>
                                {session?.tracking?.length > 0 && (
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 2 }} />
                                        <Typography sx={{
                                            color: "rgba(0, 151, 178, 1)",
                                            fontSize: { xs: '18px', md: "22px" },
                                            fontWeight: "500",
                                            fontFamily: 'Outfit',
                                            textAlign: 'left',
                                            marginBottom: '10px'
                                        }}>Tracking History</Typography>
                                        <Timeline sx={{
                                            background: "#F8F8F8",
                                            padding: '20px',
                                            borderRadius: '26px',
                                            mt: 2
                                        }}>
                                            {session.tracking.map((item, index) => (
                                                <TimelineItem key={item.id} sx={{ "&:before": { flex: 0 } }}>
                                                    <TimelineSeparator sx={{
                                                        ".MuiTimelineConnector-root": { backgroundColor: "#0097B2" }
                                                    }}>
                                                        <TimelineDot sx={{ backgroundColor: "#0097B2" }} />
                                                        {index < session.tracking.length - 1 && <TimelineConnector />}
                                                    </TimelineSeparator>
                                                    <TimelineContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                                        <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#000', fontFamily: "Outfit" }}>
                                                            {getTimelineContent(item.tracking_status)}
                                                        </Typography>
                                                        <Typography sx={{ fontSize: '12px', color: '#555', fontFamily: "Outfit" }}>
                                                            {new Date(item.date_time).toLocaleDateString()} | {new Date(item.date_time).toLocaleTimeString()}
                                                        </Typography>
                                                    </TimelineContent>
                                                </TimelineItem>
                                            ))}
                                        </Timeline>
                                    </Grid>
                                )}
                            </Grid>
                        ) : (
                            <Typography variant="body1" color="text.secondary">
                                Loading session details...
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </Box>
        </Fragment>
    );
};

export default UserSessionFullDetails;